import { adminStyles } from "../../styles/admin.styles";
import { twMerge } from "tailwind-merge";

export type AdminBqTqFormsLoadingState = "loading" | "ready" | "error";

interface Props {
  errorMessage: string | null;
  loadingState: AdminBqTqFormsLoadingState;
}

const AdminBqTqFormsStatus = ({ errorMessage, loadingState }: Props) => {
  if (errorMessage) {
    return (
      <div
        role="alert"
        data-test="admin-bq-tq-forms-error"
        className="border border-[#BF0002] bg-[#FFF1F1] px-4 py-3 text-sm text-[#8F0002]"
      >
        {errorMessage}
      </div>
    );
  }

  if (loadingState === "loading") {
    return (
      <div data-test="admin-bq-tq-forms-loading" className={twMerge(adminStyles.card.surface, "px-4 py-3 text-sm")}>
        Loading Tech Form and Baltic Questionnaire rows...
      </div>
    );
  }

  return null;
};

export default AdminBqTqFormsStatus;
